import { mountVercelToolbar } from '@vercel/toolbar';
import { useEffect } from 'react';
import { useSettings } from '@/hooks/state/useSettings';

// @TODO: Add growthbook to Vercel Toolbar
export const VercelToolbar = () => {
  const {
    settings
  } = useSettings();
  const shouldInjectToolbar = process.env.NODE_ENV === 'development' || settings?.user.hasAccountAdmin;
  useEffect(() => {
    if (shouldInjectToolbar) {
      // Returns a cleanup function to unmount the toolbar
      return mountVercelToolbar();
    }
    return () => {};
  }, [shouldInjectToolbar]);
  if (!shouldInjectToolbar) {
    return null;
  }
  return null;
};